import { ReactNode, createContext, useContext } from "react";
import { useLocalStorage } from "../hooks";

type OrderContext = {
  lastOrderId: string | number;
  setLastOrderId: (storeId: string | number) => void;
}

const OrderContext = createContext({} as OrderContext);

export const useOrder = () => {
  return useContext(OrderContext)
}

type OrderProviderProps = {
  children?: ReactNode
}

export function OrderProvider({children}: OrderProviderProps) {
  const [ lastOrderId, setLastOrderId ] = useLocalStorage<string | number>("last_order_id", "");

  return (
    <OrderContext.Provider value={{
      lastOrderId, setLastOrderId
    }}>
      {children}
    </OrderContext.Provider>
  )
}